import { Button, createStyles, makeStyles, Theme, withStyles } from "@material-ui/core";
import { LOCALES } from "../../../../globalConstants";

export function disabledEditFunctionality(info: any, data: any) {
  const phone =
    info?.phone1 === "-" && info?.phone2 === "-" ? info?.phone1 : info?.phone1 !== "-" ? info?.phone1 : info?.phone2;
  const parts = phone?.split("-");
  const phone1 = parts?.length == 2 ? parts?.[1] : parts?.[0];
  const isFirstNameIncluded = data?.firstName === info?.firstName;
  const isLastNameIncluded = data?.lastName===info?.lastName;
  const isCountryIncluded = data?.selectCountry===info?.country;
  const isContactPreferenceIncluded = data?.selectPhoneOrEmail=== info?.contactPreference;
  const isLanguageIncluded = data?.selectedSupportLanguage=== info?.language;
  const isPhone1Included = data?.number===phone1;

  return (
    isFirstNameIncluded &&
    isLastNameIncluded &&
    isCountryIncluded &&
    isContactPreferenceIncluded &&
    isLanguageIncluded &&
    isPhone1Included
  );
}
export function getSupportLanguage(value: string) {
  const foundLocale = LOCALES.find((locale) => locale.val.toLowerCase() === value.toLowerCase());
  return foundLocale;
}

export const getAlertColors = (severity: string) => {
  if (severity === "success") {
    return { backgroundColor: "#4caf50", color: "#fff" };
  } else {
    return { backgroundColor: "#e40000", color: "#fff" };
  }
};

export function validateOptions(data: any) {
  const {
    firstName,
    lastName,
    newPassword,
    pageName,
    confirmNewPassword,
    selectedSupportLanguage,
    acceptTerms,
    selectPhoneOrEmail,
    number,
  } = data;

  const regex = /[!@#$%^&*(),.?":{}|<>_-]/;
  const updatedErrors: any = {};

  function updateError(key: string, message: string) {
    updatedErrors[key] = message;
  }

  function isFieldEmpty(value: string) {
    return value.trim() === "";
  }
  function validateFirstName() {
    if (isFieldEmpty(firstName)) {
      updateError("firstName", "First name is required");
    } else if (regex.test(firstName)) {
      updateError("firstName", "First name shouldn't contain any special character");
    }
  }

  function validateLastName() {
    if (isFieldEmpty(lastName)) {
      updateError("lastName", "Last name is required");
    } else if (regex.test(lastName)) {
      updateError("lastName", "Last name shouldn't contain any special character");
    }
  }
  function validatePasswords() {
    if (isFieldEmpty(newPassword) && pageName !== "profile") {
      updateError("createPassword", "Password is required");
    }
    if (isFieldEmpty(confirmNewPassword) && pageName !== "profile") {
      updateError("confirmPassword", "Confirm password is required");
    } else if (confirmNewPassword !== newPassword && pageName !== "profile") {
      updateError("confirmPassword", "Confirm password should match create password");
    }
  }

  function validateSupportLanguage() {
    if (isFieldEmpty(selectedSupportLanguage)) {
      updateError("supportLanguage", "Please select support language");
    }
  }

  function validateTermsAcceptance() {
    if (!acceptTerms && pageName !== "profile") {
      updateError("acceptTerms", "Please accept terms and conditions");
    }
  }

  function validatePreferredContact() {
    if (isFieldEmpty(selectPhoneOrEmail)) {
      updateError("preferredContact", "Select Preferred contact");
    }
  }

  function validateContactNumber() {
    if (selectPhoneOrEmail === "mobile" && isFieldEmpty(number)) {
      updateError("contactNumber", "Please enter contact number");
    } else if (isNaN(Number(number))) {
      updateError("contactNumber", "Please enter valid contact number");
    }
  }
  validateFirstName();
  validateLastName();
  validatePasswords();
  validateSupportLanguage();
  validateTermsAcceptance();
  validatePreferredContact();
  validateContactNumber();

  return updatedErrors;
}
export const openPrivacy = () => {
  window.open("https://www.learnship.com/us/privacy-notice/", "_blank", "noopener,noreferrer");
};
export const radioList = [
  {
    id: "email",
    label: "Email",
    value: "email",
  },
  {
    id: "phone",
    label: "Contact number",
    value: "mobile",
  },
];

export const URLButton = withStyles(() => ({
  root: {
    color: "#3AA4A7",
    fontSize: "14px",
    padding: "0px",
    background: "none",
    border: "none",
    margin: "opx",
    fontWeight: "bolder",
    bottom: "2px",
    "&:hover": {
      backgroundColor: location.pathname === "/profile" ? "#f5f5f0" : "#fff",
    },
  },
}))(Button);

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    tosCheckbox: {
      display: "inline-block",
      marginLeft: "0",
      padding: "0px",
    },
    continueButton: {
      background: "#42BABD",
      fontSize: "14px",
      width: "670px",
      height: "53px",
      padding: "16px 40px 16px 40px",
      borderRadius: "0",
      gap: "8px",
      fontWeight: 600,
      color: "#424242",
      cursor: "pointer",
      boxShadow: "none",
      "&:hover": {
        backgroundColor: "#42BABD",
        boxShadow: "none",
      },
      [theme.breakpoints.down("sm")]: {
        width: "100%",
        fontSize: "14px",
        height: "auto",
      },
    },
    editButton: {
      color: "#424242",
      cursor: "pointer",
      "&:hover": {
        backgroundColor: "#fff",
        boxShadow: "none",
      },
    },
    changePasswordButton: {
      background: "#42BABD",
      color: "#1D1D16",
      padding: "10px, 24px, 10px, 24px",
      width: "168px",
      height: "39px",
      fontWeight: 500,
      font: "Noto Sans",
      fontSize: "14px",
      borderRadius: "0",
      border: "none",
      boxShadow: "none",
      cursor: "pointer",
      "&:hover": {
        backgroundColor: "#42BABD",
        boxShadow: "none",
      },
    },
  }),
);
